import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select.component';
import { InputModule } from '../input/input.module';
import { IconModule } from '../icon/icon.module';
import { LabelModule } from '../label/label.module';
import { MessageModule } from '../message/message.module';
import { FormsModule } from '@angular/forms';
import { TextModule } from '../text/text.module';
import { PillModule } from '../pill/pill.module';

@NgModule({
  declarations: [SelectComponent],
  imports: [CommonModule, InputModule, IconModule, LabelModule, MessageModule, FormsModule, TextModule, PillModule],
  exports: [SelectComponent],
})
export class SelectModule {}
